<template>
  <v-dialog
    v-model="display"
    width="500"
    persistent
    scrollable
    :fullscreen="$vuetify.breakpoint.xs"
    :transition="$vuetify.breakpoint.xs ? `dialog-bottom-transition` : `dialog-transition`"
    :content-class="
      $vuetify.breakpoint.xs
        ? `safe-area-padding-top-dialog`
        : `safe-area-padding-top safe-area-padding-bottom`
    "
  >
    <v-card
      class="p-relative overflow-hidden white--text primary"
      :class="$vuetify.breakpoint.xs ? `dialog-fullscreen` : ``"
      rounded="lg"
    >
      <hub-app-bar
        :title="currentTitle"
        hide-title
        color="primary"
        persistent
        dialog
      >
        <template slot="actions-left">
          <v-btn
            v-if="showError"
            color="secondary"
            class="flex-shrink-1 flexk-grow-1 text-capitalize"
            text
            v-text="`Close`"
            dark
            @click="close"
          />
          <v-btn
            v-else-if="view || decline"
            color="secondary"
            class="flex-shrink-1 flexk-grow-1 text-capitalize"
            text
            v-text="`Back`"
            dark
            @click="view = ``; decline = false"
          />
          <v-btn
            v-else-if="acknowledge"
            color="error"
            class="flex-shrink-1 flexk-grow-1 text-capitalize"
            text
            v-text="`Decline`"
            dark
            @click="decline = true"
          />
        </template>
        <template slot="actions-right">
          <div v-if="showError"></div>
          <v-btn
            v-else-if="decline"
            color="error"
            class="flex-shrink-1 flexk-grow-1 text-capitalize"
            text
            v-text="`Decline`"
            dark
            @click="confirmDecline"
          />
          <v-btn
            v-else-if="acknowledge && !view"
            color="success"
            class="flex-shrink-1 flexk-grow-1 text-capitalize"
            text
            v-text="`Accept`"
            dark
            @click="confirmAccept"
          />
          <v-btn
            v-else-if="!view"
            color="secondary"
            class="flex-shrink-1 flexk-grow-1 text-capitalize"
            text
            v-text="`Close`"
            dark
            @click="cancel"
          />
        </template>
      </hub-app-bar>
      <v-card-text class="pa-4 text-body-2 white--text custom-scrollbars">
        <v-container class="px-0" v-if="showError">
          <p class="text-center text-body-2" v-html="errorMessage"></p>
        </v-container>
        <v-container class="px-0" v-else-if="decline">
          <p class="text-center text-body-2">
            Are you sure you wish to decline these terms, conditions, policies or guidelines? You will be signed out imediately.
          </p>
        </v-container>
        <v-container class="px-0" v-else-if="view && documents[view]" v-html="documents[view].body"></v-container>
        <v-container class="px-0" v-else>
          <p class="text-center text-body-2" v-if="acknowledge">
            There have been updates to some of our terms, conditions, policies or guidelines. You must accept the following changes to continue using The Hub.
          </p>
          <v-list two-line color="transparent" dark>
            <v-list-item
              class="px-0"
              v-if="documents.eula"
              @click="view = `eula`"
            >
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">Terms of Service</v-list-item-title>
                <v-list-item-subtitle class="font-weight-bold">Updated: {{computeDateString(documents.eula)}}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <!-- <v-btn icon> -->
                  <v-icon class="fa-fw" small disabled>fa-chevron-right</v-icon>
                <!-- </v-btn> -->
              </v-list-item-action>
            </v-list-item>
            <v-divider />
            <v-list-item
              class="px-0"
              v-if="documents.privacy"
              @click="view = `privacy`"
            >
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">Privacy Policy</v-list-item-title>
                <v-list-item-subtitle class="font-weight-bold">Updated: {{computeDateString(documents.privacy)}}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <!-- <v-btn icon> -->
                  <v-icon class="fa-fw" small disabled>fa-chevron-right</v-icon>
                <!-- </v-btn> -->
              </v-list-item-action>
            </v-list-item>
            <v-divider />
            <v-list-item
              class="px-0"
              v-if="documents.community"
              @click="view = `community`"
            >
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">Community Guidelines</v-list-item-title>
                <v-list-item-subtitle class="font-weight-bold">Updated: {{computeDateString(documents.community)}}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <!-- <v-btn icon> -->
                  <v-icon class="fa-fw" small disabled>fa-chevron-right</v-icon>
                <!-- </v-btn> -->
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-container>
      </v-card-text>
      <v-overlay color="primary" opacity="0.85" class="p-absolute" v-if="loading">
        <v-progress-circular
          :size="70"
          :width="7"
          color="white"
          indeterminate
        ></v-progress-circular>
      </v-overlay>
    </v-card>
  </v-dialog>
</template>

<script>
import Legal from '@/modules/hub-module/services/legal'
import HubAppBar from "@/components/HubAppBar.vue";

export default {
  components: {
    HubAppBar
  },
  props: {
    acknowledge: Boolean
  },
  data() {
    return {
      display: false,
      loading: false,
      showError: false,
      errorMessage: "",
      decline: false,
      view: "",
      documents: {}
    };
  },
  computed: {
    currentTitle() {
      switch (this.view) {
        case "eula":
          return "Terms of Service";

        case "privacy":
          return "Privacy Policy";

        case "community":
          return "Community Guidelines";
      
        default:
          return "Legal";
      }
    }
  },
  methods: {
    async open() {
      this.display = true;
      this.loading = true;
      this.showError = false;
      this.decline = false;
      this.view = "";
      this.documents = {};

      Legal.clear()
      if(this.acknowledge) {
        this.documents = await Legal.checkAll().then(({data}) => data)
      } else {
        this.documents = await Legal.getAll().then(({data}) => data)
      }

      this.loading = false;
    },
    cancel() {
      this.$emit("cancel");
      this.close();
    },
    close() {
      this.display = false;
    },
    error(message) {
      this.errorMessage = message;
      this.showError = true;
      this.loading = false;
    },
    async confirmAccept() {
      this.loading = true;
      try {
        await Legal.acknowledgeAll();
        this.$emit("accept");
        this.close();
      } catch (error) {
        this.error(error)
      }
    },
    confirmDecline() {
      this.loading = true;
      this.$emit("decline");
      this.close();
    },
    computeDateString(item) {
      return new Date(item.updated).toLocaleDateString('en-AU', {year: 'numeric', month: 'long', day: 'numeric'});
    }
  },
};
</script>